import { SimpleSelect } from '@/components/form/inputs/SimpleSelect';
import { Label } from '@/components/ui/label';
import { useTranslation } from '@/hooks/useTranslation';
import { useReferenceAlias } from '@/hooks/useReferenceAlias';

type ReferenceSelectorProps = {
  references: string[];
  selectedReference: string;
  onReferenceChange: (value: string | null) => void;
};

export function ReferenceSelector({
  references,
  selectedReference,
  onReferenceChange,
}: ReferenceSelectorProps) {
  const { t } = useTranslation();
  const { resolve } = useReferenceAlias();

  if (references.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full max-w-md flex-col gap-2">
      <Label htmlFor="toolReference" className="text-sm font-medium">
        {t('analytics.dashboard.controls.referenceLabel')}
      </Label>
      <SimpleSelect
        id="toolReference"
        value={selectedReference}
        onChange={onReferenceChange}
        options={references.map((item) => ({
          label: resolve(item).label,
          value: item,
        }))}
        placeholder={t('form.select.options')}
      />
    </div>
  );
}
